import { schema } from "normalizr";
import { Permission as PermissionRecord } from "records/whiteboard";
import { List } from "immutable";

const processStrategyNewValue = (permissions) => {
    const newPermissions = (permissions.permissions || permissions).map((permission) => {
        permission.boardId = permission.board_id;
        return permission;
    });

    return {
        boardId: newPermissions[0].board_id,
        users: List(newPermissions),
    };
};

export const BoardPermission = new schema.Entity(
    "boardPermission",
    {},
    {
        idAttribute: (permissions) => {
            if (permissions.length) {
                return permissions[0].boardId;
            } else if (permissions.permissions && permissions.permissions.length) {
                // for /whiteboards permissions
                return permissions.permissions[0].board_id;
            } else {
                return permissions.board_id;
            }
        },
        processStrategy: (permissions) => {
            if (permissions.length || (permissions.permissions && permissions.permissions.length)) {
                return processStrategyNewValue(permissions);
            } else {
                return permissions;
            }
        },
    }
);

(BoardPermission as any).record = PermissionRecord;
